
import { BusinessUnitEmailContactEntityDecorator } from '../../businessunit/model/business-unit-email-contact.decorator';
import { BusinessUnitEmailContact } from '../../businessunit/model/business-unit-email-contact.model';
import { BusinessUnitEntityDecorator } from '../../businessunit/model/business-unit.decorator';
import { BusinessUnit } from '../../businessunit/model/business-unit.model';
import { CostCentreEntityDecorator } from '../../costcentre/model/cost-centre.decorator';
import { CostCentre } from '../../costcentre/model/cost-centre.model';
import { RangerSourceMapEntityDecorator } from '../../ranger_source/model/ranger-source-map.decorator';
import { RangerSourceMap } from '../../ranger_source/model/ranger-source-map.model';
import { RANGER_METADATA } from './ranger.metadata';
import { Ranger } from './ranger.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class RangerEntityDecoratorBase extends GenericEntityDecorator<Ranger, number> {
  constructor() {
    super(RANGER_METADATA, {
      get businessUnit(): EntityDecorator<BusinessUnit, string> {
        return new BusinessUnitEntityDecorator();
      },
      get costCentre(): EntityDecorator<CostCentre, string> {
        return new CostCentreEntityDecorator();
      },
      get policeContact(): EntityDecorator<BusinessUnitEmailContact, number> {
        return new BusinessUnitEmailContactEntityDecorator();
      },
      get rangerSource(): EntityDecorator<RangerSourceMap, string> {
        return new RangerSourceMapEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.rangerId == null) {
      return null;
    }
    return parseInt(params.rangerId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: Ranger): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




